import { useTranslation } from 'react-i18next';

type GadHeaderRowProps = {
  headerText: { key: number; value: string }[];
};

export function GadHeaderRow({ headerText }: GadHeaderRowProps) {
  const { t } = useTranslation();
  return (
    <div className="gad-header-row">
      <div className="gad-header-spacer" />
      <div className="gad_option_container" role="group" aria-label={t('dotRadio.header.options')}>
        {headerText.map((heading) => {
          return (
            <div className="gad-header" key={heading.key}>
              <span>{heading.value}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
